/* ELVA reserve panel.

   Used by the founding pages and by the main site. On the site the panel shows
   no price, because the price is being tested.

   The approved page's behaviour, unchanged: the reserve sheet, the three
   screens, the email typo checker, the "already reserved" state, the sticky
   bar, focus trapping and keyboard access.

   What is added here is the live wiring:

   1. The email screen is a real Shopify customer form. With JavaScript off it
      posts the page and comes back to the question screen. With JavaScript on,
      this file posts it in the background so the sheet never closes.

   2. The answer to "what's behind your dry mouth" is posted in a second
      request, and ONLY when the separate consent box is ticked. It travels as
      a customer tag. It is never passed to the Meta pixel, under any name.
*/
(function () {
  var KEY = 'elva-reserved';
  var scrim = document.getElementById('scrim');
  if (!scrim) return;
  var sheet = scrim.querySelector('.sheet'), last = null;
  var screens = {
    email: document.getElementById('s-email'),
    q: document.getElementById('s-q'),
    thanks: document.getElementById('s-thanks')
  };
  var email = document.getElementById('email'),
      err = document.getElementById('err'),
      hint = document.getElementById('hint'),
      fix = document.getElementById('fix'),
      tags = document.querySelector('[data-tags]');
  var baseTags = tags ? tags.value : 'waitlist';

  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); }
    catch (e) { return null; }
  }
  function show(n) {
    for (var k in screens) { screens[k].classList.toggle('on', k === n); }
    sheet.setAttribute('aria-labelledby', n === 'email' ? 't-email' : n === 'q' ? 't-q' : 't-thanks');
  }
  function reservedUI() {
    document.documentElement.classList.add('is-reserved');
    document.querySelectorAll('[data-open]').forEach(function (b) {
      b.textContent = b.closest('.sticky') ? 'Reserved' : 'Your kit is reserved';
    });
  }
  if (store(KEY) === '1') reservedUI();

  /* ---------- tracking ----------
     The page cannot call fbq itself: the Facebook and Instagram app runs the
     pixel inside Shopify's sandbox. So the page publishes a Shopify customer
     event instead, and the custom pixel in Settings > Customer events forwards
     it to Meta.

     Only the price version travels with the event. The email address and the
     answer to the dry mouth question are never put in an event, because events
     go to Meta and those two must not. */
  var version = (document.querySelector('[data-version]') || {}).getAttribute
    ? document.querySelector('[data-version]').getAttribute('data-version')
    : 'site';

  function track(name, extra) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var payload = { version: version };
        if (extra && extra.place) payload.place = extra.place;
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* tracking must never break the form */ }
  }

  /* ---------- open and close ---------- */
  var ckie = null;
  function open(e) {
    last = e && e.currentTarget;
    /* the banner sits where the sheet slides up, so it waits its turn */
    ckie = document.getElementById('ckie');
    if (ckie && !ckie.hidden) { ckie.hidden = true; ckie.setAttribute('data-paused', '1'); }
    track('reserve_tap', { place: last && last.closest('.sticky') ? 'sticky' : 'page' });
    if (store(KEY) === '1') { show('thanks'); } else { show('email'); err.classList.remove('on'); hint.hidden = true; }
    scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { (store(KEY) === '1' ? document.getElementById('done') : email).focus(); }, 60);
  }
  function close() {
    if (ckie && ckie.getAttribute('data-paused')) { ckie.hidden = false; ckie.removeAttribute('data-paused'); }
    scrim.classList.remove('open');
    document.body.style.overflow = '';
    if (last) last.focus();
  }
  document.querySelectorAll('[data-open]').forEach(function (b) { b.addEventListener('click', open); });
  document.getElementById('close').addEventListener('click', close);
  document.getElementById('done').addEventListener('click', close);
  scrim.addEventListener('click', function (e) { if (e.target === scrim) close(); });
  scrim.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(sheet.querySelectorAll('button,a[href],input'), function (el) {
      return el.offsetParent !== null && !el.hidden;
    });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  });

  /* ---------- the typo checker ---------- */
  var DOM = {'gmial.com':'gmail.com','gmal.com':'gmail.com','gmail.co':'gmail.com','gmail.co.uk':'gmail.com','gamil.com':'gmail.com','gnail.com':'gmail.com','hotmial.com':'hotmail.com','hotmail.co':'hotmail.co.uk','hotmal.com':'hotmail.com','yaho.com':'yahoo.com','yahoo.co':'yahoo.co.uk','outlok.com':'outlook.com','outlook.co':'outlook.com','iclod.com':'icloud.com','icloud.co':'icloud.com','btinternet.co':'btinternet.com','btinternt.com':'btinternet.com','sky.co':'sky.com'};
  function suggest(v) {
    var at = v.lastIndexOf('@'); if (at < 1) return null;
    var d = v.slice(at + 1).toLowerCase();
    return DOM[d] ? v.slice(0, at + 1) + DOM[d] : null;
  }
  email.addEventListener('input', function () {
    err.classList.remove('on'); email.removeAttribute('aria-invalid');
    var s = suggest(email.value.trim()); hint.hidden = !s; if (s) fix.textContent = s;
  });
  fix.addEventListener('click', function () { email.value = fix.textContent; hint.hidden = true; email.focus(); });

  /* ---------- posting to Shopify ----------
     The form is posted in the background so the sheet stays open. Shopify
     answers with a page, not JSON, so success is read from the final URL. */
  function postToShopify(extraTags) {
    var form = screens.email;
    var data = new FormData(form);
    if (extraTags) data.set('contact[tags]', extraTags);
    return fetch(form.getAttribute('action') || window.location.pathname, {
      method: 'POST', body: data, credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (r) {
      return { ok: r.ok, posted: /customer_posted=true/.test(r.url) };
    });
  }

  var sending = false;
  screens.email.addEventListener('submit', function (e) {
    var v = email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
      e.preventDefault(); err.classList.add('on');
      email.setAttribute('aria-invalid', 'true'); email.focus(); return;
    }
    /* no fetch means let the browser post the form the ordinary way */
    if (!window.fetch || !window.FormData) return;
    e.preventDefault();
    if (sending) return;
    sending = true;
    var btn = screens.email.querySelector('button[type=submit]');
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Reserving...'; }

    postToShopify().then(function () {
      store(KEY, '1'); reservedUI();
      track('reserve_signup');
      show('q');
      setTimeout(function () { document.getElementById('t-q').focus(); }, 60);
    }).catch(function () {
      /* the network failed, so fall back to an ordinary form post */
      screens.email.submit();
    }).then(function () {
      sending = false;
      if (btn) { btn.disabled = false; btn.textContent = label; }
    });
  });

  /* ---------- the question, and its own consent ---------- */
  var pills = document.querySelectorAll('.pill');
  pills.forEach(function (p) {
    p.addEventListener('click', function () {
      var on = p.getAttribute('aria-pressed') !== 'true';
      pills.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      p.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  });
  function chosen() {
    var p = document.querySelector('.pill[aria-pressed="true"]');
    if (!p) return '';
    return p.textContent.trim().toLowerCase()
      .replace(/[''`]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  function toThanks() {
    show('thanks');
    setTimeout(function () { document.getElementById('t-thanks').focus(); }, 60);
  }
  document.getElementById('save').addEventListener('click', function () {
    var consent = document.getElementById('consent');
    var answer = chosen();
    /* the answer is stored only with its own consent, and only in Shopify */
    if (consent && consent.checked && answer && window.fetch) {
      postToShopify(baseTags + ',cause-' + answer).then(toThanks, toThanks);
      return;
    }
    toThanks();
  });
  document.getElementById('skip').addEventListener('click', function () {
    pills.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
    document.getElementById('consent').checked = false;
    toThanks();
  });

  /* ---------- the sticky bar ---------- */
  /* the sticky bar only exists on the founding pages */
  var sticky = document.getElementById('sticky'),
      hero = document.getElementById('hero'),
      offer = document.getElementById('offer');
  if (sticky && hero && offer) {
    var bar = function () {
      var past = hero.getBoundingClientRect().bottom < 0;
      var r = offer.getBoundingClientRect();
      var atOffer = r.top < window.innerHeight && r.bottom > 0;
      sticky.classList.toggle('show', past && !atOffer);
    };
    window.addEventListener('scroll', bar, { passive: true });
    window.addEventListener('resize', bar);
    bar();
  }

  /* ---------- she has come back from an ordinary form post ---------- */
  if (/customer_posted=true/.test(window.location.search)) {
    store(KEY, '1'); reservedUI();
    scrim.classList.add('open');
    document.body.style.overflow = 'hidden';
    show('q');
    setTimeout(function () { document.getElementById('t-q').focus(); }, 60);
  }
})();
